import Projects from "./Projects";
import Teams from "./Teams";

export default function Sidebar() {
  return (
    <div className="sidebar">
      <Projects/>
      <Teams/>
    </div>
  )
}